import axios from "axios";
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, 
  headers: {
    "X-CSRFToken": getCookie("csrftoken"),
  },
});

export const registerUser = (data) => api.post("/register/", data);
export const verifyEmail  = (data) => api.post("/verify-email/", data);
export const resendOtp    = (data) => api.post("/resend-otp/", data);